import { Select } from "antd";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { SiteLabel } from "../../components/SiteLabel";
import type { TransferOrder } from "../../api-models";

const STATUSES = ["DRAFT", "PENDING_APPROVAL", "APPROVED", "DISPATCHED", "COMPLETED", "REJECTED", "CANCELLED"];

export default function TransfersListPage() {
  return (
    <ListPage<TransferOrder>
      title="Transfers"
      endpoint="/transfer-orders"
      searchPlaceholder="Search doc no or notes..."
      linkTo={(r) => `/transfers/${r.id}`}
      // The dashboard's in-transit tile links here with status=DISPATCHED.
      filters={({ value, set }) => (
        <Select
          allowClear
          placeholder="Status"
          style={{ width: 190 }}
          options={STATUSES.map((s) => ({ value: s, label: s.replaceAll("_", " ") }))}
          value={value("status")}
          onChange={(v) => set("status", v)}
        />
      )}
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "From", render: (_, r) => <SiteLabel site={r.fromSite} /> },
        { title: "To", render: (_, r) => <SiteLabel site={r.toSite} /> },
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong>
          <div>
            <SiteLabel site={r.fromSite} /> → <SiteLabel site={r.toSite} />
          </div>
          <DocumentStatusTag status={r.status} />
        </div>
      )}
    />
  );
}
